<template>
  <div class="profile-aside">
    <span class="profile-aside__title">Стать нашим оптовиком</span>
    <span class="profile-aside__description">
      Получить специальные цены и предложения на весь каталог гаджетов
    </span>
    <button @click="openModal" class="btn btn--md btn--black">
      <span>Стать партнером</span>
    </button>
  </div>
</template>

<script>
import WholesalerModal from "components/modal/components/WholesalerModal.vue";

export default {
  name: "ProfileAsideComponent",
  methods: {
    openModal() {
      this.$store.state._modals.push({
        component: WholesalerModal,
      });
    },
  },
};
</script>

<style lang="stylus">
.profile-aside {
  display grid
  justify-items center
  text-align center
  grid-gap 50px
  padding 32px 39px
  background var(--white)
  border-radius var(--main-radius)
  +below(750px) {
    background var(--light-blue)
  }

  &__title {
    font-size 1.5rem
    font-weight 500
    line-height 28px
    text-transform uppercase
    +below(600px) {
      font-size 1.25rem
      line-height 24px
    }
  }

  &__description {
    font-size 1.25rem
    line-height 32px
  }
}
</style>
